query getNewsletterOfficeDistribution($input: NewsletterOfficeDistributionInput!) {
  getNewsletterOfficeDistribution(input: $input) {
    offices {
      name
      recipientCount
      targetLink
    }
    totalOffices
    totalRecipients
  }
}
